import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/auth.service';
import { FirestoreDataService } from '../core/firestore-data.service';
import { WorkshopWork, WorkCurrentStatus } from '../core/models';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-client-portal',
  templateUrl: './client-portal.component.html',
  styleUrls: ['./client-portal.component.scss'],
  standalone: false
})
export class ClientPortalComponent implements OnInit {
  myWorks$: Observable<WorkshopWork[]> = of([]);
  
  constructor(
    public authService: AuthService,
    private firestoreService: FirestoreDataService
  ) {
    this.myWorks$ = this.authService.user$.pipe(
      switchMap(user => {
        if (user && user.email) {
          return this.firestoreService.getMyWorks(user.email);
        }
        return of([]);
      })
    );
  }

  ngOnInit(): void {}

  getSpanishStatus(status: WorkCurrentStatus | undefined): string {
    const map: Record<string, string> = {
      'Received': 'Recibida', 'In Progress': 'En Taller', 'Awaiting Parts': 'Esperando Piezas',
      'Ready': '¡Lista para retirar!', 'Completed': 'Entregada', 'Cancelled': 'Cancelada'
    };
    return map[status || ''] || 'Sincronizando...';
  }

  getStatusClass(status: WorkCurrentStatus | undefined): string {
    switch (status) {
      case 'Ready': return 'bg-success text-white shadow-success';
      case 'In Progress': return 'bg-primary text-white';
      case 'Awaiting Parts': return 'bg-warning text-dark';
      default: return 'bg-light text-dark border';
    }
  }
}